module.exports = __webpack_public_path__ + "img/usb-manage.e4961ba6.png";